module.exports = __webpack_public_path__ + "static/media/sp_sns.1ff9ec47.png";